import { cloneDeep } from 'lodash'

export const mapQuizStatistic = (statistic, blockProjection) => {
    if (statistic.blockId !== blockProjection.blockId) {
        return null
    }

    const mappedProjection = cloneDeep(blockProjection.metadata)

    mappedProjection.results = mappedProjection.results.map(result => {
        let resultStat = statistic.quizResults.find(_resultStat => _resultStat.resultId === result.id)
        if (!resultStat) {
            resultStat = {
                percent: 0,
                users: 0,
            }
        }
        return {
            ...result,
            ...resultStat,
        }
    })

    mappedProjection.questions = mappedProjection.questions.map(question => {
        let questionStat = statistic.questionsStatistic.find(_questionStat => _questionStat.questionId === question.id)
        if (!questionStat) {
            questionStat = {
                started: 0,
                answered: 0,
                answers: [],
            }
        }

        const mappedAnswers = question.answers.map(answer => {
            let answerStat = questionStat.answers.find(_answerStat => _answerStat.responseOptionId === answer.id)
            if (!answerStat) {
                answerStat = {
                    percent: 0,
                    users: 0,
                }
            }
            return {
                ...answer,
                ...answerStat,
            }
        })

        return {
            ...question,
            ...questionStat,
            answers: mappedAnswers,
        }
    })

    return mappedProjection
}
